import CategoryTab from "../components/ecommerce/categoryTab";
import Banner5 from "./../components/elements/Banner5";
import Layout from "./../components/layout/Layout";
import CategorySlider from "./../components/sliders/Category";
import Intro1 from "./../components/sliders/Intro1";
import Instagram from "../components/subscribe/subscribe";
import styled from "styled-components";
import Newsletter from "../components/newsletter/newsletter";
import Popup from "../components/popup/popup";
import HomeMobileBanner from "../components/layout/home_m_banner/Home_m_banner";
import { connect } from "react-redux";
import PatentSlider from "../components/sliders/patent/patent";
import HomeTopBanner from "../components/layout/home_top_banner/HomeTopBanner";
import ClientCompany from "@components/client-company/ClientCompany";
import BestProduct from "@components/best-product/BestProduct";
import NoticeESG from "@components/layout/NoticeESG";
import { MainBrand } from "@components/brand/MainBrand";

const SwiperSection = styled.section`
  width: 100%;
  margin-top: 15px;
  margin-bottom: 30px;

  @media (max-width: 767px) {
    margin-bottom: 20px;
  }
`;

const PopularCategoriesSection = styled.section`
  margin-bottom: 70px;

  @media (max-width: 767px) {
    margin-bottom: 40px;
  }
`;

const EventBannerSection = styled.section`
  margin-bottom: 35px;

  @media (max-width: 767px) {
    margin-bottom: 0px;
  }
`;

const NoticeSection = styled.section`
  margin-top: 45px;
  margin-bottom: 70px;

  @media (max-width: 767px) {
    margin-top: 0px;
    margin-bottom: 0px;
  }
`;

const BrandSection = styled.section`
  margin-top: 20px;
  margin-bottom: 70px;

  @media (max-width: 767px) {
    margin-top: 0px;
    margin-bottom: 0px;
  }
`;

const SectionDivider = styled.div`
  border-top: 2px solid #d9d9d9;
  margin: 0 auto 20px auto;
  width: 100%;
  width: 1120px;

  @media (max-width: 767px) {
    display: none;
  }
`;

function Home({ siteConfig, userDevice }) {
  return (
    <>
      <Popup />
      <Layout noBreadcrumb="d-none" siteConfig={siteConfig}>
        {/* 메인 상단 배너 */}
        <SwiperSection className="position-relative overflow-hidden">
          <Intro1 />
        </SwiperSection>

        {/* 상품 카테고리 */}
        <PopularCategoriesSection className="popular-categories section-padding position-relative">
          <div className="container wow animate__fadeIn animate__animated position-relative">
            <h4 className={"text-center mb-35"}>전체 서비스</h4>
            <CategorySlider siteConfig={siteConfig} />
          </div>
        </PopularCategoriesSection>

        {/* 상단 슬라이드 배너 */}
        {/*<HomeTopBanner />*/}

        {/* 실시간 베스트 */}
        <section
          className="product-tabs section-padding position-relative overflow-hidden mb-70 mb-lg-2"
          style={{
            background: "#F4F4F4",
          }}
        >
          <div className="container overflow-hidden">
            <BestProduct />
          </div>
        </section>

        {/*제휴 브랜드*/}
        <BrandSection>
          <MainBrand userDevice={userDevice} />
        </BrandSection>

        {/* 추천상품 */}
        {/*<section className="product-tabs section-padding position-relative overflow-hidden mb-70 mb-lg-2">*/}
        {/*  <div className="container overflow-hidden">*/}
        {/*    <div className="col-lg-12">*/}
        {/*      <CategoryTab />*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</section>*/}

        {/* 메인 이벤트 띠 배너 */}
        <EventBannerSection>
          <div className="container wow animate__fadeIn animate__animated">
            <HomeMobileBanner />
          </div>
        </EventBannerSection>

        {/* 공지사항 & ESG 자료실 */}
        <NoticeSection>
          <div className="container wow animate__fadeIn animate__animated">
            <NoticeESG />
          </div>
        </NoticeSection>

        {/* 스텝포넷제로 발자국 */}
        <section
          className="banners mb-2 mb-lg-5"
          style={{
            background: "#2C332D",
          }}
        >
          <div className="container">
            <div className="row">
              <Banner5 />
            </div>
          </div>
        </section>

        {/*고객사 슬라이드*/}
        <section className="mt-20 mb-70">
          <div className="container wow animate__fadeIn animate__animated">
            <ClientCompany />
          </div>
        </section>

        {/* 인기컨텐츠 */}
        {/*<section className="banners mb-2 mb-lg-5 section-padding">*/}
        {/*  <Instagram />*/}
        {/*</section>*/}

        {/* 특허 및 인증 */}
        <section className="mb-2 mb-lg-5 section-padding">
          <PatentSlider />
        </section>

        {/* 구독 */}
        <section className="banners">
          <Newsletter />
        </section>
      </Layout>
    </>
  );
}

const mapStateToProps = (state) => ({
  banners: state.banners,
});

export default connect(mapStateToProps, null)(Home);
